import styled from 'styled-components';

import { MAX_WIDTH_TABLET, MIN_WIDTH_DESKTOP } from 'utils/constants';

interface ISubitem {
  isOpen: boolean;
}

export const Subitem = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 135%;
  padding: 0px 39px;
  color: ${({ theme }) => theme.colors.textSecondary};
  border-top: 1px dashed #e0e0e0;

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    padding: 0px;
  }

  .header {
    height: auto;
    text-align: left;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0px;

    @media (max-width: ${MAX_WIDTH_TABLET}px) {
      padding-top: 20px;
      padding-bottom: 0px;
    }

    p:nth-child(1) {
      margin-right: 10px;
    }

    div:nth-child(1) {
      @media (max-width: ${MAX_WIDTH_TABLET}px) {
        margin-left: 28px;
        margin-right: 24px;
      }
    }

    div:nth-child(2) {
      margin-top: 32px;
      @media (max-width: ${MAX_WIDTH_TABLET}px) {
        margin: 20px 7px 7px 7px;
        width: auto;
      }
    }
  }

  .header p svg {
    transition: transform 0.5s;
    transform: rotate(${({ isOpen }: ISubitem) => (isOpen ? -180 : 0)}deg);
  }

  .content {
    transition: max-height 0.8s;
    max-height: ${({ isOpen }: ISubitem) => (isOpen ? 5000 : 0)}px;
    overflow: hidden;
  }

  .content > p {
    text-align: left;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 135%;
    padding-bottom: 24px;
    color: rgba(104, 104, 104, 0.8);
  }
`;

export const MainItemContent = styled.div``;

export const SubitensContent = styled.div`
  transition: max-height 0.8s;
  max-height: ${({ isOpen }: ISubitem) => (isOpen ? 5000 : 0)}px;
  overflow: hidden;
`;

export const CardToggleComponent = styled.div`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  margin-bottom: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);
  transition: box-shadow 0.25s linear, padding-left 0.25s ease-in-out;
  overflow: hidden;
  position: relative;

  @media (min-width: ${MIN_WIDTH_DESKTOP}px) {
    &:hover {
      box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);

      :after {
        left: 0;
      }

      .countSubItens > svg > rect,
      .countSubItens > svg > path {
        stroke: ${({ theme }) => theme.colors.hoverText};
      }
    }
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    left: -5px;
    top: 0;
    background: ${({ theme }) => theme.colors.hoverText};
    width: 5px;
    height: 100%;
    transition: left 0.25s ease-in-out;
  }

  .countSubItens {
    display: flex;
    align-items: center;
    font-weight: normal;
    white-space: nowrap;
  }

  .countSubItens > p {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
  }

  .countSubItens > svg {
    margin-left: 20px;

    @media (max-width: ${MAX_WIDTH_TABLET}px) {
      margin-left: 12px;
    }
  }

  .countSubItens > svg > rect {
    border-radius: 5px;
  }

  .countSubItens > svg > rect,
  .countSubItens > svg > path {
    stroke-width: 2px;
  }

  .mainitem {
    font-family: Roboto;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    cursor: pointer;
    padding-left: 39px;
    padding-right: 27px;
    color: ${({ theme }) => theme.colors.primary};
    height: 60px;
    display: flex;
    text-align: left;
    align-items: center;
    justify-content: space-between;

    @media (max-width: ${MAX_WIDTH_TABLET}px) {
      padding-left: 28px;
      padding-right: 20px;
    }
  }

  .mainitem:hover {
    @media (min-width: ${MIN_WIDTH_DESKTOP}px) {
      > p {
        color: ${({ theme }) => theme.colors.hoverText};
      }
    }
  }
`;
